import { getApiKey } from "../../utils/apiKey";
import React from "react";
import { apiCall_domain } from "../api";
import axios from "axios";
import Header from "../header";
import Spinner from "../Spinner/Spinner";
import { createGlobalStyle } from "styled-components";
class notifacation extends React.Component {
  state = {
    changeDetail: true,
    notifications: [],
    loading: true,
    handelPushHomePage: true,
  };
  componentDidMount() {
    const Headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/notifications`, {
        headers: Headers,
      })
      .then((res) => {
        this.setState({
          notifications: res.data.data.notifications,
          loading: false,
        });
      });
  }
  pushNotif(item) {
    item.type === "category" ? (
      this.props.history.push({
        pathname: `/categories/${item.item_id}/1`,
      })
    ) : item.type === "product" ? (
      this.props.history.push({
        pathname: `/product/${item.item_id}`,
      })
    ) : item.type === "order" ? (
      this.props.history.push({
        pathname: "/orderDetails",
        stateId: item.item_id,
      })
    ) : (
      <></>
    );
  }
  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #262626;
    }`;
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header
              showSearchBar={true}
              isDarkTheme={true}
              title={"اعلان ها"}
              backUrl={"/"}
            />
            {this.state.notifications.length === 0 ? (
              <div className="noNotifDivMinCom">اعلانی برای شما وجود ندارد</div>
            ) : (
              <div className="notifacationCom">
                {this.state.notifications.map((item) => (
                  <div className="notificationsMain">
                    <div className="notificationsTitle">
                      <div className="textLine">
                        <span className="readMark"></span>
                        <span className="text">{item.title}</span>
                      </div>
                      <img
                        className="leftArrowNotif"
                        src="/public/assets/icons/leftArrowNotif.svg"
                        onClick={() => this.pushNotif(item)}
                        alt="pic"
                      />
                    </div>
                    <span className="description">{item.description}</span>
                    <div className="notificationsTime">
                      <img
                        src="/public/assets/icons/clockNotif.svg"
                        alt="pic"
                      />
                      <span className="text">{item.jtime}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </>
    );
  }
}
export default notifacation;
